import { render, staticRenderFns } from "./ButtonBasic.vue?vue&type=template&id=0535e6ec&scoped=true&"
import script from "./ButtonBasic.vue?vue&type=script&lang=js&"
export * from "./ButtonBasic.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBasic.vue?vue&type=style&index=0&id=0535e6ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0535e6ec",
  null
  
)

export default component.exports